/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { CartDataFragmentDoc } from '../../../components/Bag/GraphQL/Cart.generated';
import { ValidationErrorFieldsFragmentDoc } from '../../Customer/GraphQL/ForgotPassword.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RewardsDataFragment = {
  readonly __typename?: 'Reward';
  readonly id: string;
  readonly name: string;
  readonly expirationDate: string | null;
};

export type RewardsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type RewardsQuery = {
  readonly __typename?: 'Query';
  readonly rewards: ReadonlyArray<{
    readonly __typename?: 'Reward';
    readonly id: string;
    readonly name: string;
    readonly expirationDate: string | null;
  }>;
};

export type RewardNotAppliedFieldsFragment = {
  readonly __typename?: 'RewardNotApplied';
  readonly message: string;
  readonly status: number;
  readonly failureCode: Types.ApplyRewardFailureCode;
};

export type RewardNotRemovedFieldsFragment = {
  readonly __typename?: 'RewardNotRemoved';
  readonly message: string;
  readonly status: number;
};

export type ApplyRewardMutationVariables = Types.Exact<{
  input: Types.ApplyRewardInput;
}>;

export type ApplyRewardMutation = {
  readonly __typename?: 'Mutation';
  readonly applyReward:
    | {
        readonly __typename: 'ApplyRewardSuccess';
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'RewardNotApplied';
        readonly message: string;
        readonly status: number;
        readonly failureCode: Types.ApplyRewardFailureCode;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type RemoveRewardMutationVariables = Types.Exact<{
  input: Types.RemoveRewardInput;
}>;

export type RemoveRewardMutation = {
  readonly __typename?: 'Mutation';
  readonly removeReward:
    | {
        readonly __typename: 'RemoveRewardSuccess';
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename?: 'LedgerItem';
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename?: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
            }>;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: {
                readonly __typename?: 'Asset';
                readonly url: string;
              };
              readonly ingredients: ReadonlyArray<{
                readonly __typename?: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename?: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
          };
          readonly availableWantedTimes: ReadonlyArray<{
            readonly __typename?: 'AvailableWantedTime';
            readonly time: string;
          }>;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            };
          } | null;
        };
      }
    | {
        readonly __typename: 'RewardNotRemoved';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const rewardsQueryMock: ExecutionResult<RewardsQuery> = {
  data: {
    rewards: [
      {
        id: '509e6ea9-fee4-42a9-9625-87ce71904308',
        name: 'Hello World',
        expirationDate: 'Hello World',
      },
      {
        id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
        name: 'Hello World',
        expirationDate: 'Hello World',
      },
      {
        id: '47534319-d080-460b-99aa-250f9c4016b1',
        name: 'Hello World',
        expirationDate: 'Hello World',
      },
    ],
  },
};

export const applyRewardMutationMock: ExecutionResult<ApplyRewardMutation> = {
  data: { applyReward: { __typename: 'ApplyRewardSuccess', order: {} } },
};

export const removeRewardMutationMock: ExecutionResult<RemoveRewardMutation> = {
  data: { removeReward: { __typename: 'RemoveRewardSuccess', order: {} } },
};
export const RewardsDataFragmentDoc = gql`
  fragment RewardsData on Reward {
    id
    name
    expirationDate
  }
`;
export const RewardNotAppliedFieldsFragmentDoc = gql`
  fragment RewardNotAppliedFields on RewardNotApplied {
    message
    status
    failureCode
  }
`;
export const RewardNotRemovedFieldsFragmentDoc = gql`
  fragment RewardNotRemovedFields on RewardNotRemoved {
    message
    status
  }
`;
export const RewardsDocument = gql`
  query Rewards {
    rewards {
      ...RewardsData
    }
  }
  ${RewardsDataFragmentDoc}
`;

export function useRewardsQuery(
  options?: Omit<Urql.UseQueryArgs<RewardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<RewardsQuery, RewardsQueryVariables>({
    query: RewardsDocument,
    ...options,
  });
}
export const ApplyRewardDocument = gql`
  mutation applyReward($input: ApplyRewardInput!) {
    applyReward(input: $input) {
      __typename
      ... on ApplyRewardSuccess {
        order {
          ...CartData
        }
      }
      ...ValidationErrorFields
      ...RewardNotAppliedFields
    }
  }
  ${CartDataFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
  ${RewardNotAppliedFieldsFragmentDoc}
`;

export function useApplyRewardMutation() {
  return Urql.useMutation<ApplyRewardMutation, ApplyRewardMutationVariables>(
    ApplyRewardDocument,
  );
}
export const RemoveRewardDocument = gql`
  mutation removeReward($input: RemoveRewardInput!) {
    removeReward(input: $input) {
      __typename
      ... on RemoveRewardSuccess {
        order {
          ...CartData
        }
      }
      ...ValidationErrorFields
      ...RewardNotRemovedFields
    }
  }
  ${CartDataFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
  ${RewardNotRemovedFieldsFragmentDoc}
`;

export function useRemoveRewardMutation() {
  return Urql.useMutation<RemoveRewardMutation, RemoveRewardMutationVariables>(
    RemoveRewardDocument,
  );
}
